// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1BulkForecastsImportSchema } from './v1/bulk/forecastsImportSchema';
import { v1BulkForecastsImportResponseSchema } from './v1/bulk/forecastsImportResponseSchema';

export const bulkImportTasksPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const bulkImportTasksHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Tasks imported successfully
 */
export const bulkImportTasks200Schema = z.lazy(() => v1BulkForecastsImportResponseSchema);

export const bulkImportTasksMutationRequestSchema = z.lazy(() => v1BulkForecastsImportSchema);

export const bulkImportTasksMutationResponseSchema = z.lazy(() => bulkImportTasks200Schema);
